// extracted by mini-css-extract-plugin
export default {"wrapper":"Select_wrapper__nlWM8","label":"Select_label__LuGYO","control":"Select_control__gNRtg","select":"Select_select__X-ksl","caret":"Select_caret__Hc1AN"};